import { z } from 'zod';

export const createComponentSchema = z.object({
  name: z.string().trim().min(1, { message: 'Name is required' }),
  schema: z.object({
    fields: z.array(z.any()),
    version: z.literal(1),
  }),
});
